




























































import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { namespace, Getter, State } from 'vuex-class'
import { getMarkerColorsFromThemeId } from 'bits/map_theme'
import { Post, PostColor, Cid } from '../types'
import { processedUrl } from '@padlet/vivaldi-client'
import SurfaceBeethovenPreview from 'vuecomponents/surface_beethoven_preview.vue'
import debounce from 'lodash.debounce'
import Draggable from 'vuedraggable'
import { computePostIndexFromPost } from 'surface/sorter'
import { isAppUsing } from 'bits/flip'
@Component({
  components: { SurfaceBeethovenPreview, Draggable },
})
export default class SurfaceMapPostPreviewPanel extends Vue {
  @Prop() isShown
  @Prop() posts
  @Prop() themeId

  @State dpr
  @(namespace('map').Getter) postWithMarkerHighlightedCid
  @(namespace('map').Action) openPostPopup
  @(namespace('map').Action) highlightPostMarker
  @(namespace('post').Action) sortedPost

  debouncedHighlightPostMarker = debounce(this.highlightPostMarker, 250, { leading: true, trailing: true })

  neverShown = true
  hoveredPostCid = null

  // DRAGGING
  dragging = false
  draggableSortablePostArray: Post[] = []
  isReactiveStoreSyncingFrozenForSorting = false
  updatePostArray(currentPosts) {
    this.draggableSortablePostArray = currentPosts
  }

  get currentPosts() {
    return this.posts
  }

  @Watch('currentPosts', { immediate: true })
  respondToCurrentPostsChange(currentPosts) {
    if (this.isReactiveStoreSyncingFrozenForSorting) return
    this.updatePostArray(currentPosts)
  }

  freezeUpdating() {
    this.isReactiveStoreSyncingFrozenForSorting = true
  }

  unfreezeUpdating() {
    this.isReactiveStoreSyncingFrozenForSorting = false
    this.$nextTick(() => {
      this.updatePostArray(this.currentPosts)
    })
  }

  onStartDrag(e) {
    this.dragging = true
    this.freezeUpdating()
    // setTimeout(() => {
    //   debugger
    // }, 500);
  }

  @Watch('dragging')
  respondToDragging(dragging) {
    if (dragging) {
      this.$emit('start-reordering')
    } else {
      this.$emit('stop-reordering')
      this.hoveredPostCid = null
    }
  }

  reorder(postCid: Cid, oldIndex: number, newIndex: number): void {
    if (isAppUsing('wishOrderArray')) {
      const postOrder = this.draggableSortablePostArray.map((p) => p.cid)
      let laterPostCid
      let earlierPostCid
      earlierPostCid = postOrder[newIndex + 1] || null
      laterPostCid = postOrder[newIndex - 1] || null

      this.sortedPost({
        postCid: postCid,
        previousCid: earlierPostCid,
        nextCid: laterPostCid,
      })
    }
    if (!isAppUsing('wishOrderArray')) {
      const postOrder = this.draggableSortablePostArray.map((p) => p.id)
      let laterPostId
      let earlierPostId
      earlierPostId = postOrder[newIndex - 1] || null
      laterPostId = postOrder[newIndex + 1] || null
      const sortIndex = computePostIndexFromPost(null, {
        nextId: laterPostId === null ? null : `wish-preview-${laterPostId}`,
        prevId: earlierPostId === null ? null : `wish-preview-${earlierPostId}`,
      }).sortIndex
      this.sortedPost({
        postCid: postCid,
        sortIndex: sortIndex,
      })
    }
  }

  onEndDrag(e) {
    this.dragging = false
    this.reorder(e.item.dataset.postCid, e.oldIndex, e.newIndex)
    this.unfreezeUpdating()
  }
  // OTHERS
  @Watch('isShown')
  onFirstOpen(isShown): void {
    if (this.neverShown && isShown) {
      this.neverShown = false
    }
  }

  openPost(postCid): void {
    this.openPostPopup({ postCid })
  }

  onPostHover(postCid): void {
    if (!this.dragging) {
      this.hoveredPostCid = postCid
    }
  }

  onPostUnhover(postCid): void {
    this.hoveredPostCid = null
  }

  @Watch('hoveredPostCid')
  respondToHoveredPostChanged(hoveredPostCid) {
    this.highlightPostMarker({ postCid: hoveredPostCid })
  }

  getSubtitleStyle(color: PostColor): any {
    if (!color) return null
    return {
      color: '#' + getMarkerColorsFromThemeId(this.themeId).fill[color],
    }
  }

  previewUrl(url): string {
    return processedUrl(url, { height: 56, width: 56, dpr: this.dpr })
  }
}
